"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var Reception = function Reception(_ref) {
  var name = _ref.name,
    fill = _ref.fill,
    className = _ref.className,
    title = _ref.title;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    className: "icon ".concat(className, " d8-svg-").concat(name),
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("title", null, title || name), /*#__PURE__*/_react["default"].createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(-259.000000, -5605.000000)",
    stroke: fill,
    strokeWidth: "1.5"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(250.000000, 5596.000000)"
  }, /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(10.000000, 10.000000)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M2.43421053,0.131578947 L2.43421053,2.76315789 C2.43421053,4.0348662 3.4651338,5.06578947 4.73684211,5.06578947 C6.00855041,5.06578947 7.03947368,4.0348662 7.03947368,2.76315789 L7.03947368,0.131578947 L2.43421053,0.131578947 Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M8.02631579,9.34210526 C8.02631579,7.88872434 6.84811776,6.71052632 5.39473684,6.71052632 L4.07894737,6.71052632 C2.62556645,6.71052632 1.44736842,7.88872434 1.44736842,9.34210526"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M19.8684211,19.8684211 L19.8684211,13.2894737 C19.8684211,12.5627832 19.279322,11.9736842 18.5526316,11.9736842 L1.44736842,11.9736842 C0.720677961,11.9736842 0.131578947,12.5627832 0.131578947,13.2894737 L0.131578947,19.8684211"
  }), /*#__PURE__*/_react["default"].createElement("line", {
    x1: "8.02631579",
    y1: "14.6052632",
    x2: "8.02631579",
    y2: "18.5526316"
  }), /*#__PURE__*/_react["default"].createElement("line", {
    x1: "10.6578947",
    y1: "14.6052632",
    x2: "10.6578947",
    y2: "18.5526316"
  }), /*#__PURE__*/_react["default"].createElement("line", {
    x1: "8.02631579",
    y1: "16.5789474",
    x2: "10.6578947",
    y2: "16.5789474"
  }), /*#__PURE__*/_react["default"].createElement("line", {
    x1: "2.43421053",
    y1: "2.76315789",
    x2: "7.03947368",
    y2: "2.76315789"
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    points: "13.2894737 6.71052632 18.5526316 6.71052632 18.5526316 9.34210526 13.2894737 9.34210526"
  }), /*#__PURE__*/_react["default"].createElement("line", {
    x1: "15.9210526",
    y1: "9.34210526",
    x2: "15.9210526",
    y2: "11.9736842"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M18.5526316,2.76315789 L16.5789474,2.76315789 L16.5789474,2.10526316 C16.5789474,1.01522747 17.4625959,0.131578947 18.5526316,0.131578947 L18.5526316,4.07894737"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.6315789,1.11842105 C12.6315789,0.573403207 13.0734032,0.131578947 13.6184211,0.131578947 L13.6184211,0.131578947 C14.1634389,0.131578947 14.6052632,0.573403207 14.6052632,1.11842105 L14.6052632,1.11842105 C14.6047067,1.4372108 14.4961775,1.74641096 14.2973684,1.99561404 L12.6315789,4.07894737 L14.6052632,4.07894737"
  }))))));
};
Reception.propTypes = {
  name: _propTypes["default"].string.isRequired,
  title: _propTypes["default"].string,
  fill: _propTypes["default"].string,
  className: _propTypes["default"].string
};
Reception.defaultProps = {
  fill: '#ffffff',
  className: ''
};
var _default = exports["default"] = Reception;